import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import {
    BiListOl, BiCheckSquare, BiChevronDownCircle, BiStar,
    BiImage, BiCommentDetail, BiPhotoAlbum, BiRadioCircle, BiText,
} from 'react-icons/bi';
import { FieldType, FIELD_TYPE_LABELS } from '../../types/template';

const PALETTE_ITEMS: { type: FieldType; icon: React.ReactNode }[] = [
    { type: 'multiple_choice', icon: <BiListOl size={16} /> },
    { type: 'single_choice',   icon: <BiRadioCircle size={16} /> },
    { type: 'checkboxes',      icon: <BiCheckSquare size={16} /> },
    { type: 'dropdown',        icon: <BiChevronDownCircle size={16} /> },
    { type: 'star_rating',     icon: <BiStar size={16} /> },
    { type: 'textbox',         icon: <BiText size={16} /> },
    { type: 'comment_box',     icon: <BiCommentDetail size={16} /> },
    { type: 'image_upload',    icon: <BiImage size={16} /> },
    { type: 'image_choice',    icon: <BiPhotoAlbum size={16} /> },
];

function PaletteItem({ type, icon }: { type: FieldType; icon: React.ReactNode }) {
    const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
        id:   `palette-${type}`,
        data: { type, isPaletteItem: true },
    });

    const style = transform ? { transform: CSS.Translate.toString(transform) } : undefined;

    return (
        <div
            ref={setNodeRef}
            style={style}
            className={`field-palette__item${isDragging ? ' field-palette__item--dragging' : ''}`}
            {...listeners}
            {...attributes}
        >
            {icon}
            <span>{FIELD_TYPE_LABELS[type]}</span>
        </div>
    );
}

export default function FieldPalette() {
    return (
        <div className="field-palette">
            <div className="field-palette__title">Components</div>
            {PALETTE_ITEMS.map(item => (
                <PaletteItem key={item.type} type={item.type} icon={item.icon} />
            ))}
        </div>
    );
}
